<template>
		<!-- Page header -->
		<div class="page-header">
			<div class="page-header-content">
				<div class="page-title">
					<h4><i class="icon-arrow-left52 position-left"></i> {{ $route.meta.title }}</h4>
				</div>
			</div>
		</div>
		<!-- /page header -->
</template>

<script>
export default {

  name: 'Breadcrumb',

  data () {
    return {

    }
  }
}
</script>

<style lang="css" scoped>
</style>


// WEBPACK FOOTER //
// src/components/admin/master/Breadcrumb.vue